import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Styles } from "./styles/breadcrumb.js";
import Button from "../shared/Button.jsx";
import styled from "styled-components";

export const BreadcrumbBox = ({
  title,
  previousPath = "/",
  previousTitle = "Home",
  image = "/assets/images/test.jpg",
  preTitle,
  centerTitle = false,
  registerButton = false,
  registerLink = "/",
  externalLink = "",
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Styles>
      <section
        className="breadcrumb-area"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}${image})`,
        }}
      >
        <Container>
          <Row>
            <Col md="12">
              <div
                className={`breadcrumb-box ${
                  centerTitle ? "centered-box" : ""
                }`}
              >
                {preTitle && (
                  <h4 className="breadcrumb-pre-title">{t(preTitle)}</h4>
                )}
                <h2 className="breadcrumb-title">{t(title)}</h2>
                {registerButton && (
                  <Button
                    className="register-button"
                    onClick={() => navigate(registerLink)}
                    text={"Register"}
                  />
                )}
                {externalLink && (
                  <StyledLink
                    href={externalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("Register")}
                  </StyledLink>
                )}

                {!centerTitle && (
                  <Breadcrumb>
                    <Breadcrumb.Item onClick={() => navigate(previousPath)}>
                      {t(previousTitle)}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>{t(title)}</Breadcrumb.Item>
                  </Breadcrumb>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
};

export default BreadcrumbBox;

const StyledLink = styled.a`
  margin-top: 24px;
  display: flex;
  align-items: center;
  background-color: #662a30;
  color: #fff !important;
  border: none;
  border-radius: 8px;
  padding: 8px 30px;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  &:hover {
    background-color: #d3ae6e;
  }
`;
